/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, total: NonNullable<unknown> }} Directory_Agent_Readiness_Group_CountInputs */

const en_directory_agent_readiness_group_count = /** @type {(inputs: Directory_Agent_Readiness_Group_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} of ${i?.total} verified`)
};

const zh_directory_agent_readiness_group_count = /** @type {(inputs: Directory_Agent_Readiness_Group_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}/${i?.total} 已核验`)
};

/**
* | output |
* | --- |
* | "{count} of {total} verified" |
*
* @param {Directory_Agent_Readiness_Group_CountInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agent_readiness_group_count = /** @type {((inputs: Directory_Agent_Readiness_Group_CountInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agent_Readiness_Group_CountInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agent_readiness_group_count(inputs)
	return zh_directory_agent_readiness_group_count(inputs)
});
export { directory_agent_readiness_group_count as "directory.agent_readiness.group_count" }